module.exports = __webpack_public_path__ + "img/avatar3.d8317433.svg";